import { render, staticRenderFns } from "./customsDeclaration.vue?vue&type=template&id=881823e6&scoped=true&"
import script from "./customsDeclaration.vue?vue&type=script&lang=js&"
export * from "./customsDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881823e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('881823e6')) {
      api.createRecord('881823e6', component.options)
    } else {
      api.reload('881823e6', component.options)
    }
    module.hot.accept("./customsDeclaration.vue?vue&type=template&id=881823e6&scoped=true&", function () {
      api.rerender('881823e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/customsDeclaration.vue"
export default component.exports